import { reactive } from '@nzyme/vue-utils/reactivity/reactive.js';
import { useDataSource } from '@nzyme/vue-utils/useDataSource.js';
import { computed, toValue } from 'vue';
import { getFullName } from '@sigma/utils/getFullName.js';
/**
 * Shared load + formatting for the "doctor joined" chat status card. The app-specific
 * staff store is injected via `load`, so both app views become thin wrappers around this.
 */
export function useChatStaffJoin(options) {
    const staff = useDataSource({
        params: () => toValue(options.staffId),
        // useDataSource does not skip undefined params — guard so no request fires with undefined.
        load: staffId => (staffId ? options.load(staffId) : Promise.resolve(undefined)),
        behavior: 'eager',
    });
    return reactive({
        loaded: computed(() => staff.loaded),
        firstName: computed(() => staff.value?.firstName),
        lastName: computed(() => staff.value?.lastName),
        title: computed(() => (staff.value ? getFullName(staff.value.firstName, staff.value.lastName) : '')),
        isDoctor: computed(() => staff.value?.roles?.includes('DOCTOR')),
    });
}
//# sourceMappingURL=useChatStaffJoin.js.map